export const ConnectBusinessProfileModalCss = {
  mainBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardSx: {
    textAlign: 'center',
    width: '100%',
    padding: '16px',
    marginTop: '24px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginTop: '8px',

    marginLeft: 'auto',
    marginRight: 'auto'
  },
  btnSx: {
    maxHeight: '48px',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    marginTop: '24px'
  },
  btnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-white)'
  },
  imgSx: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '16px',
    width: '251px',
    maxWidth: '415px',
    height: '145px'
  },
  imgBox: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    marginTop: '16px'
  },
  watchTutorialSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  connectBtnBox: {
    display: 'flex',
    gap: '8px'
  },
  skipText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)'
  },
  skipBtnSx: {
    maxHeight: '48px',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    marginTop: '24px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    maxWidth: '646px'
  },
  skipBtnBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  skipOnBoardingBtnSx: {
    marginTop: '14px'
  }
};

export const ConfirmConnectionModalCss = {
  mainBoxSx: {
    padding: '32px',
    textAlign: 'center'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    flex: 1,
    marginLeft: '32px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginTop: '8px'
  },
  cancelTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    cursor: 'pointer'
  },
  btnSx: {
    maxHeight: '48px',
    borderRadius: '6px',
    padding: '12px 18px 12px 18px',
    marginBottom: '16px'
  },
  imgSx: {
    marginTop: '32px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '32px'
  }
};

export const SkipOnboardingModalCss = {
  mainBoxSx: {
    padding: '32px',
    textAlign: 'left'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: '800 !important',
    fontSize: 'var(--font-size-20)',
    lineHeight: '27px',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-22)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    marginTop: '8px'
  },
  cancelTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    cursor: 'pointer'
  },
  btnSx: {
    maxHeight: '48px',
    borderRadius: '6px',
    padding: '12px 18px 12px 18px',
    marginBottom: '16px'
  }
};

export const LocalSeoLocationCardSx = {
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '10px',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  selectProfileBtnText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  selectProfileBtn: {
    maxHeight: '40px',
    borderWidth: '1px',
    borderRadius: '6px',
    padding: '10px 16px 10px 16px',
    borderColor: 'var(--color-text-muted-purple)',
    minWidth: '160px'
  },
  skipOnboardingBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    justifyContent: 'center',
    marginTop: '16px'
  },
  selectOnboardingBtn: {
    maxHeight: '40px',
    borderWidth: '1px',
    borderRadius: '6px',
    padding: '10px 16px 10px 16px',
    minWidth: '160px'
  },
  chooseAnotherAccountTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    marginTop: '16px',
    cursor: 'pointer'
  },
  chooseAccountBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
  }
};

export const LocalSeoAllSx = {
  manageReviewsBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '32px'
  },
  manageReviewsBtnSx: {
    maxHeight: '72px',
    borderRadius: '6px',
    borderWidth: '1px',
    padding: '12px 16px 12px 16px',
    borderColor: 'var(--color-border-muted)',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D'
  },
  manageReviewsBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-28)',
    color: 'var(--color-primary)'
  },
  starIconSx: {
    color: '#FBBC04',
    width: '24px',
    height: '24px'
  },
  postingMainHeadBox: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '24px'
  },
  googleBusinessProfilePostsSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  googleBusinessProfilePostsDescSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-purple)',
    marginTop: '8px'
  },
  postingSearchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  postingCreateNewPost: {
    maxHeight: '44px',
    minWidth: '170px',
    padding: '10px 18px 10px 18px',
    borderRadius: '6px'
  },
  postingCreateNewPostTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-white)'
  },
  postingRowImgBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  postingRowPostTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  postingRowTypeTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  },
  postingRowCreatorTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  postingTableCellText: {
    paddingTop: '8px !important',
    paddingBottom: '8px !important'
  },
  selectedBusinessNameText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  nonSelectedBusinessNameText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-dark2)'
  },
  oneTimeAddOnBtn: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    paddingTop: '12px',
    paddingRight: '8px',
    paddingBottom: '12px',
    paddingLeft: '8px',
    gap: '8px',
    borderRadius: '6px',
    maxHeight: '48px',
    marginBottom: '16px',
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid var(--color-text-muted-purple)'
  },
  saveModalFooterText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '8px',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  saveModalFooterSpanText: {
    color: 'var(--color-purple-strong)',
    textDecoration: 'underline',
    cursor: 'pointer',
    textUnderlineOffset: '4px', // adds space between text and underline
    textDecorationThickness: '1px' // optional: control thickness
  },
  postingMainHeadBoxNoData: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    alignItems: 'center'
  },
  localSeoTaskDescSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-purple)',
    marginTop: '6px',
    marginBottom: '16px',
    maxWidth: '900px'
  },
  localSeoTaskProgressCountText: {
    fontSize: 'var(--font-size-14)',
    textAlign: 'left',
    fontWeight: 400,
    color: 'var(--color-primary)',
    fontFamily: 'Inter'
  },
  localSeoProgressSx: {
    width: '100%',
    bgcolor: 'var(--color-bg-light-neutral)',
    height: 8,
    borderRadius: 32
  },
  localSeoLoader: {
    minHeight: '300px',
    width: '100%',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center'
  },
  perSx: {
    //styleName: Text lg/Semibold;
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
    textAlign: 'left'
  },
  addonFooter: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '6px',
    textAlign: 'center'
  },
  clickOnLearnMore: {
    color: 'var(--color-primary)',
    textDecoration: 'underline',
    textDecorationThickness: '1.2px',
    cursor: 'pointer',
    textUnderlineOffset: '4px'
  },
  businessFilterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    backgroundColor: 'white',
    minWidth: '240px',
    minHeight: '44px',
    borderRadius: '6px',
    padding: '8px 16px 8px 16px',
    border: '1px solid var(--color-border-muted)',
    gap: '16px',
    width: 'max-content'
  },
  extraFilterBoxSx: {
    width: 'fit-content',
    maxWidth: '580px',
    marginLeft: 'auto',
    marginTop: '24px'
  },
  businessTitle: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  businessListItemBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '16px'
  },
  addProfileBtn: {
    maxHeight: '40px',
    borderRadius: '6px',
    padding: '10px 16px 10px 16px'
  },
  addProfileText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  filterBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    backgroundColor: 'white',
    minWidth: '170px',
    minHeight: '44px',
    borderRadius: '6px',
    padding: '8px 16px 8px 16px',
    border: '1px solid var(--color-border-muted)',
    gap: '16px'
  },
  selectedFilterSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  avatarBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  }
};

export const CreateNewPostCss = {
  mainContainer: {
    marginTop: '24px',
    display: 'flex',
    gap: '24px',
    width: '100%'
  },
  createNewPostBox: {
    width: '50%'
  },
  previewBox: {
    width: '50%'
  },
  cardTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  createNewPostSpacingBox: {
    marginTop: '24px',
    width: '100%'
  },
  businessNameSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px'
  },
  formControlLabel: {
    fontWeight: 400,
    fontSize: '12px !important'
  },
  postImageMainBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px'
  },
  postImageBox: {
    minWidth: '128px',
    height: '128px',
    borderRadius: '6px',
    border: '1px solid var(--color-border)',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  postImageDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  uploadImageTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    width: '100%',
    marginTop: '10px'
  },
  uploadIconSx: {
    marginLeft: 'auto',
    marginRight: 'auto',
    cursor: 'pointer'
  },
  otherInfoSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-22)',
    color: 'var(--color-primary)'
  },
  switchBoxSx: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center'
  },
  createNewPostLowSpacingBox: {
    marginTop: '16px'
  },
  createNewPostBtnBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  scheduleThisPostBtnSx: {
    height: '40px',
    borderRadius: '6px',
    borderWidth: '1px',
    padding: '10px 16px 10px 16px',
    borderColor: 'var(--color-text-muted-purple)'
  },
  saveAndPostBtnSx: {
    height: '40px',
    borderRadius: '6px',
    padding: '10px 16px 10px 16px'
  },
  scheduleThisPostBtnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  postImageDescBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '8px'
  },
  postImageDescIconBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  formControlLabelTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: 'var(--line-height-18)'
  },
  detailsRemainingText: {
    position: 'absolute',

    right: 16,
    color: 'var(--color-text-placeholder)',
    pointerEvents: 'none',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'right'
  },
  uploadedSx: {
    width: '100%',
    height: '100%',
    borderRadius: '6px'
  },
  uploadIconBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  dateFieldBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  previewDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)'
  },
  previewDescBoxSx: {
    minHeight: '600px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  previewDataBox: {
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    width: '100%',
    maxWidth: '360px',
    marginTop: '24px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  previewDataImg: {
    maxHeight: '184px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    height: 'auto'
  },
  previewDataSpacingBox: {
    padding: '16px'
  },
  previewDataPostDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-dark-grey)',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line' //  This is the key
  },
  previewSelected: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: '#0B57D0',
    paddingTop: '10px',
    paddingBottom: '10px',
    textAlign: 'center'
  },
  previewDataPostTitle: {
    wordBreak: 'break-word', // Ensures long words break
    whiteSpace: 'normal',
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    marginBottom: '10px'
  },
  previewDataCouponCode: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-24)',
    lineHeight: '100%',
    textAlign: 'center'
  },
  previewDataCouponCodeBox: {
    padding: '10px',
    border: '1px solid #DFE1EC',
    width: '100%',
    marginTop: '10px'
  },
  createPostLoaderBox: {
    minHeight: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  deleteModalBox: {
    paddingBottom: '16px',
    minWidth: { xs: '100%', sm: '485px' }
  },
  deleteModalDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-dark-grey)',
    wordBreak: 'break-word', // Ensures long words break
    whiteSpace: 'normal' // Allows normal wrapping
  },
  deleteModalBtnBox: {
    display: 'flex',
    gap: '8px',
    marginTop: '18px',
    justifyContent: 'end'
  },
  deleteModalBtnSx: {
    maxHeight: '44px'
  },
  postingSearchBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px'
  }
};

export const ManageReviewsCss = {
  yourReviewsSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)'
  },
  cardsMainBox: {
    display: { xs: 'grid', md: 'flex' },
    gap: '16px',
    width: '100%',
    marginTop: '24px'
  },
  manageReviewsBoxSx: {
    padding: '24px'
  },
  rowCommentText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  rowDisplayNameSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 'var(--line-height-16)',
    marginTop: '4px',
    color: 'var(--color-black)'
  },
  rowRatingTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  },
  rowRatingBoxSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  rowStartIcon: {
    color: 'var(--color-warning-yellow)',
    width: '16px',
    height: '16px'
  },
  rowLanguage: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },

  replyTextsSpanStyle: {
    fontWeight: 700
  },
  enterReply: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px'
  },

  replyFooterText: {
    fontSize: '12px',
    color: 'grey',
    fontFamily: 'Inter',
    fontWeight: 400,
    marginLeft: '12px',
    lineHeight: 'var(--line-height-16)',
    marginTop: '4px',
    wordWrap: 'break-word'
  },
  deleteModalBtnBox: {
    display: 'flex',
    gap: '8px',
    marginTop: '18px',
    justifyContent: 'end'
  },
  replyModalBtnBox: {
    display: 'flex',
    gap: '8px',
    marginTop: '24px',
    justifyContent: 'end'
  },
  replyModalBox: (isWidget: boolean = false, options: any = {}) => ({
    padding: '24px',
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter'
  }),

  replyModalDetailsBox: {
    marginTop: '24px'
  },

  replyTextsSx: (isWidget: boolean = false, options: any = {}) => ({
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-near-black)',
    marginTop: '8px',
    wordWrap: 'break-word'
  }),

  replyRatingBoxSx: {
    display: 'flex',
    alignItems: 'end',
    gap: '8px'
  },

  reviewReplyBox: {
    marginTop: '24px'
  },

  replyReviewTextsSx: (isWidget: boolean = false, options: any = {}) => ({
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)',
    wordWrap: 'break-word'
  }),

  boldText: (isWidget: boolean = false, options: any = {}) => ({
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    color: 'var(--color-primary)',
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter'
  }),

  rowBtnSx: (isWidget: boolean = false, options: any = {}) => ({
    minWidth: '88px',
    maxHeight: '36px',
    padding: '6px 18px',
    borderRadius: '6px',
    border: `1px solid ${
      isWidget
        ? options?.accentColor || 'var(--color-primary)'
        : 'var(--color-primary)'
    }`,
    color: isWidget ? options?.accentColor || '' : '',
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter'
  }),
  deleteMultipleKeywordTitle: (
    isWidget: boolean = false,
    options: any = {}
  ) => ({
    color: 'var(--color-primary)',
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center'
  }),
  ownerReplyTextsSx: (isWidget: boolean = false, options: any = {}) => ({
    fontFamily: isWidget ? options?.font || 'Inter' : 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)',
    marginTop: '8px',
    wordWrap: 'break-word'
  }),
  replyWrapper: {
    display: 'flex',
    gap: 1.5,
    mt: 3
  },

  replyDivider: {
    borderLeft: '2px solid rgba(0,0,0,0.12)',
    borderRadius: '2px'
  },

  replyContentWrapper: {
    flex: 1
  },

  replyHeaderBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1
  },

  replyAvatar: {
    bgcolor: 'var(--color-border-grey)',
    color: 'var(--color-text-dark3)',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    width: 36,
    height: 36,
    flexShrink: 0
  },

  replyNameRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '6px',
    flexWrap: 'wrap'
  },

  replyName: (isWidget: boolean = false, options: any = {}) => ({
    fontFamily: options?.font || 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    color: 'var(--color-near-black-grey)',
    lineHeight: 'var(--line-height-20)'
  }),

  replyTime: (isWidget: boolean = false, options: any = {}) => ({
    fontFamily: options?.font || 'Inter',
    fontSize: '12px',
    color: 'rgba(32, 33, 36, 0.7)'
  }),

  replyBadge: {
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    bgcolor: 'var(--color-border-grey)',
    px: 1,
    py: '1px',
    borderRadius: '4px',
    color: 'var(--color-near-black-grey)'
  }
};

export const TimeLineDropdownSx = {
  mainBox: {
    border: '1px solid var(--color-border-grey)',
    borderRadius: '6px',
    padding: '10px 12px',
    cursor: 'pointer',
    minWidth: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 'var(--font-size-16)'
  },
  optionBox: {
    px: 2,
    py: 1,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--color-bg-grey)'
    }
  },
  selectedOptionText: {
    fontSize: 'var(--font-size-16)',
    fontWeight: 400
  }
};

export const OpeningTimesComponentCss = {
  mainBox: { display: 'flex', gap: '24px', flexDirection: 'column' },
  hoursText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black2)'
  },
  descTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-dark-grey)',
    marginTop: '6px',
    marginBottom: '6px'
  },
  radioBtnLabelSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black2)'
  }
};

export const SelectedLocalSeoTaskCss = {
  mainTitleSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    marginTop: '20px'
  },
  containerSx: {
    marginTop: '24px',
    display: 'flex',
    gap: '24px',
    flexWrap: { xs: 'wrap', ms: 'nowrap' }, // xs:0, ms:700
    marginBottom: '2rem'
  },
  cardSx: {
    width: '100%',
    borderRadius: '6px',
    padding: '16px',
    backgroundColor: 'var(--color-white)',
    border: '1px solid var(--color-border-muted)',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  body: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%',
    color: 'var(--color-text-secondary)'
  },
  subheading: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  priorityValue: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%'
  },
  link: {
    color: 'var(--color-purple-strong)',
    textDecoration: 'none',
    cursor: 'pointer'
  },
  containedButton: {
    maxHeight: '44px',
    gap: '8px',
    borderRadius: '6px',
    borderWidth: '1px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D'
  },
  outlinedButton: {
    maxHeight: '44px',
    gap: '8px',
    borderRadius: '6px',
    paddingTop: '10px',
    paddingRight: '18px',
    paddingBottom: '10px',
    paddingLeft: '18px',
    border: '1px solid var(--color-text-muted-purple)',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D'
  },
  linkColor: {
    '& a': {
      color: 'var(--color-purple-strong)',
      textDecoration: 'underline',
      textDecorationThickness: '1.2px',
      cursor: 'pointer',
      textUnderlineOffset: '4px'
    }
  },
  taskCardBoxSx: {
    marginTop: '16px',
    borderRadius: '6px',
    padding: '16px',
    backgroundColor: 'var(--color-bg-light-purple)'
  },
  tipTextTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  tipBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  tipDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '12px'
  },
  qrBox: {
    width: 134,
    height: 130,
    marginTop: '56px',
    marginBottom: '30px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  qrCode: {
    width: '100%',
    height: '100%'
  }
};

export const LocalSeoStepperCss = {
  mainBox: {
    marginTop: '24px'
  },
  mainTitle: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)',
    textAlign: 'center',
    marginBottom: '32px'
  },
  firstSiteBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  siteBoxWidth: {
    maxWidth: '500px'
  },
  stepperBox: {
    mt: 5, // Margin top
    mb: 4,
    width: '100%',
    height: 'auto',
    // maxWidth: '500px',
    margin: '0 auto',
    textAlign: 'center'
  },
  stepLabelBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  stepNumber: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    border: '2px solid var(--color-secondary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold'
  },
  stepText: {
    fontWeight: 'bold',
    color: 'var(--color-primary)'
  },
  stepperIcon: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500
  },
  stepNumSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15.73px',
    textAlign: 'center'
  },
  stepLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: '15.73px',
    textAlign: 'center'
  },
  stepper: {
    maxWidth: '435px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '& .MuiStepConnector-root': {
      paddingLeft: '15px',
      paddingRight: '15px'
    },
    '& .MuiStepConnector-line': {
      borderColor: 'var(--color-text-placeholder) !important',
      borderTopWidth: '2px'
    }
  },
  tabs: {
    borderWidth: '0px 0px 1px 1px',
    borderStyle: 'solid',
    borderColor: 'var(--color-border-muted)',
    borderRadius: '12px 0px 0px 12px',
    marginTop: '25%',
    '& .MuiTabs-indicator': {
      display: 'none' // Hides the indicator
    }
  },
  setupMonitoringSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '8px'
  },
  setupMonitoringDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    marginBottom: '16px'
  },
  frequencySx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginBottom: '8px'
  }
};

export const TrackingFrequencyCss = {
  mainBox: {
    padding: '32px'
  }
};

export const localSeoChipFieldSx = {
  textFieldSx: {
    '& .MuiOutlinedInput-root': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '4px 5px',
      borderRadius: '6px',
      border: '1px solid var(--color-border)',
      '& fieldset': { border: 'none' },
      '&:hover fieldset': { border: 'none' },
      '&.Mui-focused fieldset': { border: 'none' },
      gap: '8px'
    },
    '& input': {
      padding: '4px 0',
      minWidth: '150px',
      flexGrow: 1
    }
  },
  chipSx: {
    backgroundColor: 'var(--color-success-bg)',
    height: 28
  },
  closeIconSx: {
    color: 'var(--color-text-dark) !important',
    fontSize: '18px !important'
  },
  boxSx: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
    minHeight: '28px',
    marginY: '2px'
  },
  formControlLabel: {
    mr: 3,
    '.MuiFormControlLabel-label': {
      fontSize: 'var(--font-size-16)',
      fontWeight: 400,
      fontColor: 'var(--color-text-light-grey)'
    }
  }
};

export const datePickerCss = {
  textFieldSx: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: 44,
      borderRadius: '6px',
      cursor: 'pointer'
    },
    '& .MuiInputBase-input': {
      padding: '8px 14px',
      cursor: 'pointer'
    }
  },
  popOverMainBoxSx: {
    bgcolor: 'white',
    borderRadius: '6px',
    boxShadow: 3,
    p: 2,
    fontFamily: 'sans-serif',
    minHeight: '415px'
  },
  popOverHeadBox: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: 1
  },
  typo: {
    fontSize: 14,
    fontWeight: 500,
    color: 'var(--color-primary)'
  },
  datePickerBox: {
    maxHeight: '305px',
    '& .MuiPickersCalendarHeader-root': {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      marginBottom: 1
    },
    '& .MuiPickersSlideTransition-root': {
      minHeight: 0,
      margin: 0
    },
    '& .MuiDayPicker-weekContainer': {
      margin: 0
    },
    '& .MuiDayPicker-header': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& .MuiPickersDay-root': {
      margin: 0,
      height: 36,
      width: 36,
      fontSize: 13,
      borderRadius: '6px'
    }
  }
};
